import { createSubtitlesCustomMenu } from './create-subtitles-custom-menu'
import { getWindowColorMenuItems } from './lib'

/**
 * Settings subtitles window color menu
 */
export const SettingsSubtitlesWindowColorMenu = createSubtitlesCustomMenu(
  'SettingsSubtitlesWindowColorMenu',
  'window_color',
  getWindowColorMenuItems
)
